module.exports = __webpack_public_path__ + "static/media/search-icon.393065ac.svg";